import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { IngredientsServices } from "../../services";
import { Uploads } from "../../../services/uploads";
import { StaticsServices } from '../../../services/statics';
import { IngredientCompCreateSelectIngPage } from '../../ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-create-select-ing';
import { IngredientCreateSelectProviderPage } from '../../ingredient-create/ingredient-create-select-provider/ingredient-create-select-provider';
import { HttpParams, HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { StockElementPage } from '../../../analytics/reports/stock-element/stock-element';
import { StockCostEvolutionPage } from '../../../analytics/reports/stock-cost-evolution/stock-cost-evolution';
import { ArticleViewPage } from '../../../articles/articles-view/article-view';
import { StockListPage } from '../../../stock/stock-list/stock-list';
import { DeliberyNoteViewPage } from '../../../delibery_note/delibery-note-view/delibery-note-view/delibery-note-view';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { ProviderOrderCartPage } from '../../../providers/orders/provider-order-cart/provider-order-cart';
import { ProvidersServices } from '../../../providers/services';
import { IngredientViewLabelPage } from '../ingredient-view-label/ingredient-view-label';

/**
 * Generated class for the IngredientViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view',
    templateUrl: 'ingredient-view.html',
})
export class IngredientViewPage {

    ingredient_uid: string;
    ingredient: any = Array();
    valueChanges: any;
    ingredient_name: string;
    new_element;
    loader_deliveries: boolean = false;
    total_5_deliveries: any

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public ingredientsServices: IngredientsServices,
        public uploadServices: Uploads,
        public staticsServices: StaticsServices,
        public http: HttpClient,
        public translate: TranslateService,
        public analyticsService: AnalyticsServices,
        public providersServices: ProvidersServices) {

    }

    ionViewWillLeave() {
        if (this.new_element === true && this.navCtrl.getActive().name == 'IngredientViewPage') {
            this.navCtrl.setRoot(StockListPage, {});
        }
    }

    ionViewWillEnter() {

        // busca si es nuevo elemento
        this.new_element = this.navParams.get('new_element');

        this.globals.GAtrackView('Ingredients', 'Ingredients - View', this.globals.restaurant.email, 'View', 'View ingredient', 'Ingredients', '');

        this.ingredient_uid = this.navParams.get('ingredient_uid');
        this.ingredient_name = this.navParams.get('ingredient_name');
        // buscamos los lotes
        this.FindLots();

        this.ingredientsServices.ingredientDoc = this.ingredientsServices.afs.doc('ingredients/' + this.ingredient_uid); //Recuperamos el ingrediente para tener el plato simpre actulizado.
        this.valueChanges = this.ingredientsServices.ingredientDoc.valueChanges().subscribe(value => {
            value.UID = this.ingredient_uid; //Anadimos el UID al plato
            this.ingredient = value;
            if (typeof this.ingredient.created_at != 'object') {
                this.ingredient.created_at = undefined;
            }
            this.getImageUrl(this.ingredient.image);//Get url from image

            //ordenar tags
            value.tags = this.globals.orderNamesByAlphabetical(value.tags);
            //check providers
            if (!this.ingredient.providers && !this.ingredient.sub_recipe) {
                this.editProviders();
            }
        });

        if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {//version pro abierto
            this.getDishesWithIngredient();
            this.getProductsWithIngredient();
        }

        if (!this.ingredient.sub_recipe) {
            if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {//version pro abierto


                this.getIngredientCostLastMonth();
            }
        }
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-ingrediente'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Ingredients', 'Ingredients - Delete', this.globals.restaurant.email, 'Delete', 'Delete ingredient', 'Ingredients', this.ingredient.name);
                        this.valueChanges.unsubscribe();
                        //
                        if (this.ingredientsServices.filteredIngredientsActive) {
                            this.ingredientsServices.filteredIngredients.splice(this.ingredientsServices.filteredIngredients.findIndex(item => item.UID == this.ingredient_uid), 1);
                        }
                        //
                        this.ingredientsServices.delete(this.ingredient_uid);
                        this.staticsServices.changeStateStaticWait(true);//cambia static_wait a true para poder hacer los updates mas tarde
                        this.staticsServices.addDeleteStaticToQueue(this.ingredient_uid, 'deletes_ing_update');//añade la linia de eliminado al _queue para tirar el update stastics
                        this.analyticsService.trackingExpStock('delete_ingredient', this.globals.tracking_exp['delete_ingredient'], this.ingredient_uid);
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }
    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.pop();
        loadingPopup.dismiss();
    }

    getImageUrl(image_ref) {
        //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
        this.ingredientsServices.image_url_ingr_view = null
        if (image_ref) {
            const ref = this.uploadServices.storage.ref(image_ref);
            this.ingredientsServices.image_url_ingr_view = ref.getDownloadURL();
        }

    }

    editCIngredients() {
        this.navCtrl.push(IngredientCompCreateSelectIngPage, {
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            ingredients: this.ingredient,
            ingredient_name: this.ingredient.name,
            ingredient_measurement: this.ingredient.measurement
        });

    }

    editProviders() {
        this.navCtrl.push(IngredientCreateSelectProviderPage, {
            update_state: true,
            ingredient_uid: this.ingredient.UID,
            ingredients: this.ingredient,
            ingredient_name: this.ingredient.name,
            ingredient_measurement: this.ingredient.measurement
        });
    }

    openDish(dish) {
        this.navCtrl.push(ArticleViewPage, {
            article_type: 'dish',
            article_uid: dish.uid
        });
    }
    openProduct(product) {
        this.navCtrl.push(ArticleViewPage, {
            article_type: 'product',
            article_uid: product.uid
        });
    }

    list_dishes_with_ingredient: any = [];
    getDishesWithIngredient() {
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('ingredient_uid', this.ingredient_uid);
        this.http.post(this.globals.analytics_path + 'biingredient/get_dishes_have_ingredient', params, {})
            .subscribe(async res => {
                this.list_dishes_with_ingredient = res;
            });
    }

    list_products_with_ingredient: any = [];
    getProductsWithIngredient() {
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('ingredient_uid', this.ingredient_uid);
        this.http.post(this.globals.analytics_path + 'biingredient/get_products_have_ingredient', params, {})
            .subscribe(async res => {
                this.list_products_with_ingredient = res;
            });
    }

    public _ingredient_cost_last_months: any = 0;
    public ingredient_cost_state = '';
    public ingredient_cost_percent: any; //mostraremos el procentaje en la view
    public _ingredient_foodcost = 0;
    async getIngredientCostLastMonth() {
        let today = moment();
        let date = await today.subtract(90, 'days').format("YYYY-MM-DD");

        await this.globals.delay(1000);

        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('ingredient_name', this.ingredient_name)
            .set('last_date', date);
        this.http.post(this.globals.analytics_path + 'biingredient/get_ingredient_cost_last_months', params, {})
            .subscribe(async res => {
                this._ingredient_cost_last_months = res['ingredient_cost_last_months'];


                if (this.ingredient.sub_recipe) {
                    this._ingredient_foodcost = this.ingredient.price_static / this.ingredient.real_weight; // calculamos foodcost del dish
                } else {
                    this._ingredient_foodcost = this.ingredient.price_static / 1; // calculamos foodcost del dish
                }

                this.ingredient_cost_percent = 100 - this.globals.regla3(this._ingredient_cost_last_months, this._ingredient_foodcost);

                if (this._ingredient_cost_last_months > this._ingredient_foodcost) {
                    this.ingredient_cost_state = 'positive';
                } else {
                    this.ingredient_cost_state = 'negative';
                    this.ingredient_cost_percent = Math.abs(this.ingredient_cost_percent);
                }
            });
    }

    async print() {
        this.globals.GAtrackView('Ingredient', 'Ingredient - Sheet - Print ', this.globals.restaurant.email, 'View', 'Print sheet', 'Ingredient', this.ingredient_name);

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();

        //Format values
        var ingredient_image;

        if (!this.ingredientsServices.image_url_ingr_view) {
            ingredient_image = '';
        } else {
            await this.ingredientsServices.image_url_ingr_view.subscribe(data => {
                ingredient_image = data;
            });
        }

        this.http.post(this.globals.api_path + 'ingredient/sub_recipe/print',
            {
                ingredient: this.ingredient,
                ingredient_image: ingredient_image,
                company: this.globals.restaurant.company,
            }, {})
            .subscribe(res => {
                if (this.globals.so_mobile) {
                    window.location.assign(String(res['file']));
                } else {
                    window.open(String(res['file']), '_blank');
                }
                loadingPopup.dismiss();
            }, error => {
                loadingPopup.dismiss();
            });
    }

    openModalVersionPro() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    openProviderOrderAdd(element) {
        this.navCtrl.push(ProviderOrderAddPage, {
            element: element,
            type: 'ingredient-comp'

        });
    }

    changeSubRecipe() {

        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-title-cambiar-estado-ing-prod'),
            message: this.translate.instant('general-cambiar-estado-ing-prod'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        if (this.ingredient.sub_recipe) {


                            //simple
                            if (this.ingredient.providers) {
                                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
                                    'sub_recipe': false,
                                    'updated_user': this.globals.user_name,
                                    'updated_at': new Date(),
                                });
                            } else {
                                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
                                    'providers': [],
                                    'provider_static': "",
                                    'sub_recipe': false,
                                    'updated_user': this.globals.user_name,
                                    'updated_at': new Date(),
                                });
                                this.editProviders();
                            }

                        } else {
                            //compuesto

                            if (this.ingredient.foodcost) {
                                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
                                    'sub_recipe': true,
                                    'updated_user': this.globals.user_name,
                                    'updated_at': new Date(),
                                });

                            } else {
                                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
                                    'foodcost': [],
                                    'ingredient_include_subrecipe': true,
                                    'time': "",
                                    'tools': "",
                                    'real_weight': 0,
                                    'recipe': "",
                                    'sub_recipe': true,
                                    'updated_user': this.globals.user_name,
                                    'updated_at': new Date(),
                                });
                            }

                        }
                    }
                }
            ]
        });
        alert.present();
    }


    openElementStockAnalytics(ingredient) {
        this.navCtrl.push(StockElementPage, {
            element: ingredient
        });
    }

    openStockCostEvolutionPage(element) {
        if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {
            this.navCtrl.push(StockCostEvolutionPage, {
                element: element
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }


    // buscar els lots
    total_lotes: any = [];
    show_all_lotes: boolean = false;
    FindLots() {
        this.total_5_deliveries = []
        this.http.post(this.globals.analytics_path + 'FindLots',
            {
                uid_element: this.ingredient_uid,
                type_element: 'ingredient',
                uid_restuarant: this.globals.restaurant_uid

            }, {})
            .subscribe(res => {
                this.total_lotes = res;
                this.total_5_deliveries = this.total_lotes.slice(0, 5);
                this.loader_deliveries = true;
            }, error => {
                this.loader_deliveries = true;
            });

    }

    change_show_lotes() {
        if (this.show_all_lotes) {
            this.show_all_lotes = false;
        } else {
            this.show_all_lotes = true;
        }
    }

    SerachDelibery(delivery_uid, element) {
        this.navCtrl.push(DeliberyNoteViewPage, {
            delibery_note_uid: delivery_uid,
        })
    }

    onSelectTab(selectedTab) {
        var tab_ative = document.getElementsByClassName('tab-pane') as HTMLCollectionOf<HTMLElement>;
        for (var i = 0, max = tab_ative.length; i < max; i++) {
            if (tab_ative[i] != undefined) {
                tab_ative[i].classList.remove('active');
            }
        }
        var doc = document.getElementById(selectedTab);
        doc.classList.add('active');
    }

    openCart() {
        if (this.globals.checkLimitsByLicense('stock', 'pedidos')) {
            this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
            this.navCtrl.push(ProviderOrderCartPage);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
        this.globals.open_side_menu = false;
    }

    printLabel() {
        if (this.globals.checkLimitsByLicense('stock', 'print')) {//version pro abierto
            this.navCtrl.push(IngredientViewLabelPage, {
                ingredient: this.ingredient
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view/ingredient-view.ts